import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { HelpersModule } from '@core/components/helpers/helpers.module';

import { CoreCustomFormsHelpersSearchFiltersModule } from '../../helpers/filters/filters.module';
import { FillEmailTextV1FieldComponent } from './fill-email-text-v1/fill-email-text-v1.component';
import { ViewEmailTextV1FieldComponent } from './view-email-text-v1/view-email-text-v1.component';
import { SettingsEmailTextV1FieldComponent } from './settings-email-text-v1/settings-email-text-v1.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersModule,
        CoreCustomFormsHelpersSearchFiltersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA ],
    declarations: [
        FillEmailTextV1FieldComponent,
        ViewEmailTextV1FieldComponent,
        SettingsEmailTextV1FieldComponent
    ],
    exports: [
        FillEmailTextV1FieldComponent,
        ViewEmailTextV1FieldComponent,
        SettingsEmailTextV1FieldComponent
    ],

})
export class CoreCustomFormsFieldEmailTextV1FieldsModule { }
